import { Link } from "react-router-dom";
import { ArrowRight, LinkedinLogo } from "@phosphor-icons/react";
import { usePageMeta, PAGE_META } from "@/lib/pageMeta";
import { FOUNDER, SiteFooter, SiteNav } from "@/components/landing/SiteChrome";

export default function About() {
  usePageMeta(PAGE_META.about);
  return (
    <div className="bg-[#050505] min-h-screen" data-testid="about-page">
      <SiteNav />
      <main className="mx-auto max-w-4xl px-6 py-20 md:py-28">
        <p className="font-mono text-xs text-[#00FF9D] mb-4">// ABOUT</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold leading-tight">The person behind CalibRunway.</h1>
        <section data-testid="founder-card" className="mt-12 rounded-2xl border border-[#2A2A2A] bg-[#121212] p-6 sm:p-10 flex flex-col sm:flex-row gap-8">
          <div aria-hidden="true" data-testid="founder-initials"
            className="h-24 w-24 shrink-0 rounded-full border border-[#00FF9D]/60 bg-[#00FF9D]/10 flex items-center justify-center font-display text-3xl text-[#00FF9D]">{FOUNDER.initials}</div>
          <div>
            <h2 data-testid="founder-name" className="font-display text-2xl">{FOUNDER.name}</h2>
            <p className="text-sm text-[#A3A3A3] mt-1">{FOUNDER.title}</p>
            <blockquote data-testid="founder-why" className="mt-6 border-l-2 border-[#00FF9D] pl-4 text-base md:text-lg leading-relaxed">“{FOUNDER.why}”</blockquote>
            <a href={FOUNDER.linkedin} target="_blank" rel="noopener noreferrer" data-testid="founder-linkedin-link"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#2A2A2A] px-4 py-2 text-sm hover:border-white transition-colors">
              <LinkedinLogo size={16} className="text-[#00C2FF]" /> Connect on LinkedIn
            </a>
          </div>
        </section>
        <section className="mt-12 grid md:grid-cols-2 gap-6 text-sm text-[#A3A3A3] leading-relaxed">
          <div>
            <h2 className="font-display text-xl text-white">The company</h2>
            <p data-testid="about-company" className="mt-2">{FOUNDER.company}. We build tools that give founders a direct, honest view of their cash, without the spreadsheet.</p>
          </div>
          <div>
            <h2 className="font-display text-xl text-white">Your data</h2>
            <p className="mt-2">We read your Stripe, bank and QuickBooks data only to build your model. We never move money or sell your data. <Link to="/security" data-testid="about-security-link" className="text-[#00FF9D] underline">Read how we handle it</Link>.</p>
          </div>
        </section>
        <Link to="/sign-up" data-testid="about-cta-btn" className="mt-14 inline-flex items-center gap-2 rounded-full bg-[#00FF9D] px-7 py-3.5 font-semibold text-[#050505] hover:shadow-[0_0_32px_rgba(0,255,157,0.45)] transition-shadow">
          Start 14-Day Free Trial <ArrowRight weight="bold" />
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
